<div id="add-photo-modal" class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Select Item to Add</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>

    <br />
    <span>{{totalPhotos}} images loaded.</span>
    <br />

    <div class="ttmodal__body" style="width: 700px; height:720px">
        <div id="photoList">
            <ng-container *ngFor="let ep of photos">
                <div *ngIf="ep.data != ''" class="img-container">
                    <img [src]="'data:image/png;base64,'+ep.data" class="img-item"
                         [matTooltip]="ep.title + ' - ' + ep.comment" (click)="addSelectedImage($event, ep.id, ep.photoType)" /> 
                </div>
            </ng-container>
        </div>
    </div>
</div>